import { apiRequest } from './apiClient';

const BASE = '/api/istatistik';

export const fetchCihazlar = async ({ sayfa = 1, limit = 25, arama } = {}) => {
  const query = { sayfa, limit };
  if (arama != null && String(arama).trim() !== '') query.arama = String(arama).trim();
  return apiRequest(`${BASE}/cihazlar`, { method: 'GET', query });
};

const withDonem = (query, donem) => ({ ...query, donem: donem || '1yil' });

export const fetchArizaOzet = async ({ sekme, donem } = {}) => {
  return apiRequest(`${BASE}/ariza-ozet`, { method: 'GET', query: withDonem({ sekme }, donem) });
};

export const fetchArizaListe = async ({ sayfa = 1, limit = 25, arama, donem } = {}) => {
  const query = withDonem({ sayfa, limit }, donem);
  if (arama != null && String(arama).trim() !== '') query.arama = String(arama).trim();
  return apiRequest(`${BASE}/ariza`, { method: 'GET', query });
};

export const fetchArizaMusteri = async ({ sayfa = 1, limit = 25, arama, donem } = {}) => {
  const query = withDonem({ sayfa, limit }, donem);
  if (arama != null && String(arama).trim() !== '') query.arama = String(arama).trim();
  return apiRequest(`${BASE}/ariza-musteri`, { method: 'GET', query });
};

export const fetchArizaMusteriServisKayitlari = async (musteriId, { sayfa = 1, limit = 10, donem } = {}) => {
  return apiRequest(`${BASE}/ariza-musteri/${encodeURIComponent(musteriId)}/servis-kayitlari`, {
    method: 'GET',
    query: withDonem({ sayfa, limit }, donem),
  });
};

export const fetchArizaMusteriZaman = async (musteriId, donem) => {
  return apiRequest(`${BASE}/ariza-musteri/${encodeURIComponent(musteriId)}/zaman`, {
    method: 'GET',
    query: { donem: donem || '1yil' },
  });
};

export const fetchArizaUrun = async ({ sayfa = 1, limit = 25, arama, donem } = {}) => {
  const query = withDonem({ sayfa, limit }, donem);
  if (arama != null && String(arama).trim() !== '') query.arama = String(arama).trim();
  return apiRequest(`${BASE}/ariza-urun`, { method: 'GET', query });
};

export const fetchArizaUrunArizalar = async (urunId, donem) => {
  return apiRequest(`${BASE}/ariza-urun/${encodeURIComponent(urunId)}/arizalar`, {
    method: 'GET',
    query: { donem: donem || '1yil' },
  });
};

export const fetchArizaUrunZaman = async (urunId, donem) => {
  return apiRequest(`${BASE}/ariza-urun/${encodeURIComponent(urunId)}/zaman`, {
    method: 'GET',
    query: { donem: donem || '1yil' },
  });
};

export const fetchArizaZaman = async (arizaId, donem) => {
  return apiRequest(`${BASE}/ariza/${encodeURIComponent(arizaId)}/zaman`, {
    method: 'GET',
    query: { donem: donem || '1yil' },
  });
};

export const fetchArizaUrunleri = async (arizaId, donem) => {
  return apiRequest(`${BASE}/ariza/${encodeURIComponent(arizaId)}/urunler`, {
    method: 'GET',
    query: { donem: donem || '1yil' },
  });
};

export const fetchArizaUrunServisKayitlari = async (urunId, arizaId, { sayfa = 1, limit = 25, donem } = {}) => {
  return apiRequest(
    `${BASE}/ariza-urun/${encodeURIComponent(urunId)}/arizalar/${encodeURIComponent(arizaId)}/servis-kayitlari`,
    { method: 'GET', query: withDonem({ sayfa, limit }, donem) },
  );
};
